<template>
  <form-select v-bind="$attrs" ref="select" v-model="_value" :options="employees" @object="returnObject" :errors="valueNotInOptions ? [valueNotInOptions] : []" />
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  props: {
    modelValue: {
      type: [String, Array]
    }
  },
  emits: ['update:modelValue', 'object'],
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['profile', 'employees']),
    valueNotInOptions() {
      if (!this.modelValue) return null
      // if value is array and empty, return null
      if (Array.isArray(this.modelValue)) {
        if (!this.modelValue.length) return null
        return !this.modelValue.every((item) => this.employees.map((item) => item.value.toString()).includes(item.toString()))
          ? `'${this.modelValue}' is not an option`
          : null
      }
      if (!this.employees?.length) return null
      return !this.employees.map((item) => item.value.toString()).includes(this.modelValue.toString()) ? `'${this.modelValue}' is not an option` : null
    },
    _value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  mounted() {},
  methods: {
    returnObject(val) {
      this.$emit('object', {
        name: val?.label,
        id: val?.value
      })
    }
  }
}
</script>

<style lang="postcss" scoped>
span.multiselect__single {
  @apply text-center font-bold text-base;
}
</style>
